// state context object
import { createContext } from 'react';

const StateContext = createContext(null);

export default StateContext